import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import { func, arrayOf, shape, string, array, bool, oneOf, number } from 'prop-types';
import Flex from '../../atoms/Flex';
import Attribute from '../../molecules/Attribute';
import AttributeColor from '../../molecules/AttributeColor';
import AttributeVolume from '../../molecules/AttributeVolume';
const Attributes = {
  color: AttributeColor,
  size: Attribute,
  voltage: Attribute,
  volume: AttributeVolume
};

const getVariationsValueByType = variations => variations == null ? void 0 : variations.reduce((acc, variation) => {
  var _ref;

  acc[variation.type] = Object.assign({}, acc[variation.type], {
    [variation.value]: [...(((_ref = (acc == null ? void 0 : acc[variation.type]) || {}) == null ? void 0 : _ref[variation.value]) || []), variation]
  });
  return acc;
}, {});

const addVariationsToAttributes = (attributes, variations) => attributes.map((attribute, i) => {
  var _ref2, _variationsByValue$at, _attributes, _attributes2;

  const variationsByValue = getVariationsValueByType(variations);
  return Object.assign({}, attribute, {
    variations: (_ref2 = (variationsByValue == null ? void 0 : (_variationsByValue$at = variationsByValue[(_attributes = attributes[i - 1]) == null ? void 0 : _attributes.type]) == null ? void 0 : _variationsByValue$at[(_attributes2 = attributes[i - 1]) == null ? void 0 : _attributes2.current]) || variations) == null ? void 0 : _ref2.reduce((acc, variation) => new Array(...new Set([...acc, variation.id])), [])
  });
});

const AttributeList = _ref3 => {
  let {
    onAttributeChange,
    attributes,
    variations,
    title,
    alignment,
    colorMinLength,
    colorVariant,
    fullWidth,
    showTitle,
    style,
    onVariationClick,
    showWarningText,
    warningMessage,
    iconWarningText
  } = _ref3,
      props = _objectWithoutPropertiesLoose(_ref3, ["onAttributeChange", "attributes", "variations", "title", "alignment", "colorMinLength", "colorVariant", "fullWidth", "showTitle", "style", "onVariationClick", "showWarningText", "warningMessage", "iconWarningText"]);

  const minLengths = {
    color: colorMinLength
  };
  const variants = {
    color: colorVariant
  };
  const attributesVariations = addVariationsToAttributes(attributes, variations);
  return /*#__PURE__*/React.createElement(Flex, {
    flexDirection: "column",
    width: 1,
    rowGap: 3
  }, attributesVariations.map((attribute, index) => {
    const AttributeComponent = Attributes[attribute == null ? void 0 : attribute.type] || Attribute;
    const currentVariations = variations.filter(variation => attribute.variations.includes(variation.id) && variation.type === attribute.type);
    return /*#__PURE__*/React.createElement(AttributeComponent, _extends({
      fullWidth: fullWidth,
      key: `${attribute == null ? void 0 : attribute.type}-${index}`,
      attribute: attribute,
      variations: currentVariations,
      onChange: onAttributeChange,
      onVariationClick: onVariationClick,
      title: title,
      alignment: alignment,
      minLength: minLengths[attribute == null ? void 0 : attribute.type],
      variant: variants[attribute == null ? void 0 : attribute.type],
      showTitle: showTitle,
      style: style,
      showWarningText: showWarningText,
      warningMessage: warningMessage,
      iconWarningText: iconWarningText
    }, props));
  }));
};

AttributeList.defaultProps = {
  attributes: [],
  alignment: 'center',
  colorVariant: 'smooth',
  fullWidth: false,
  variations: [],
  showTitle: true,
  style: {},
  onVariationClick: null,
  showWarningText: false,
  warningMessage: '',
  iconWarningText: ''
};
process.env.NODE_ENV !== "production" ? AttributeList.propTypes = {
  onAttributeChange: func.isRequired,
  attributes: arrayOf(shape({
    label: string,
    type: string,
    current: string,
    selected: bool,
    values: array
  })),
  variations: arrayOf(shape({
    label: string,
    type: string,
    value: string,
    id: string
  })),
  title: string,
  onVariationClick: func,
  colorMinLength: number,
  fullWidth: bool,
  alignment: oneOf(['center', 'start', 'end']),
  colorVariant: oneOf(['smooth', 'button']),
  showTitle: bool,
  style: shape({}),
  showWarningText: bool,
  warningMessage: string,
  iconWarningText: string
} : void 0;
export default AttributeList;